export class Toast {
  private static activeToasts: HTMLElement[] = [];

  static show(message: string, type: 'info' | 'warning' | 'error' = 'info', duration = 3000): void {
    const toast = document.createElement('div');
    toast.style.cssText = `
      position: fixed;
      bottom: 20px;
      right: 20px;
      background: ${this.getBackgroundColor(type)};
      color: white;
      padding: 12px 16px;
      border-radius: 8px;
      font-family: ui-sans-serif, system-ui;
      font-size: 14px;
      font-weight: 600;
      z-index: 999999998;
      box-shadow: 0 4px 12px rgba(0,0,0,0.3);
      transition: all 0.3s ease;
      transform: translateX(100%);
      opacity: 0;
    `;
    toast.textContent = message;
    document.documentElement.appendChild(toast);
    this.activeToasts.push(toast);

    // Animate in
    requestAnimationFrame(() => {
      toast.style.transform = 'translateX(0)';
      toast.style.opacity = '1';
    });

    // Remove after duration
    setTimeout(() => {
      this.remove(toast);
    }, duration);
  }

  private static remove(toast: HTMLElement): void {
    toast.style.transform = 'translateX(100%)';
    toast.style.opacity = '0';

    setTimeout(() => {
      const index = this.activeToasts.indexOf(toast);
      if (index > -1) {
        this.activeToasts.splice(index, 1);
      }
      toast.remove();
    }, 300);
  }

  private static getBackgroundColor(type: string): string {
    switch (type) {
      case 'warning':
        return '#f59e0b';
      case 'error':
        return '#ef4444';
      default:
        return '#10b981';
    }
  }

  static clearAll(): void {
    this.activeToasts.forEach((toast) => this.remove(toast));
  }
}
